<div class="p-field w-full" [ngClass]="options.containerClass">
  <ng-container
    *ngIf="
      options.fieldFormGroup || options.fieldFormGroup === '';
      else elseTemplate
    "
  >
    <ng-container [formGroup]="specificFormGroup">
      <label class="mb-2" *ngIf="options.label"
        >{{ options.label | translate }}
        <span
          *ngIf="options?.validators?.required"
          [pTooltip]="'BUTTONS.required' | translate"
          tooltipPosition="top"
          class="text-pink-500"
          >*</span
        ></label
      >
      <p-chips
        styleClass="w-full"
        class="w-full"
        [formControlName]="options.formControlName"
        (input)="onChange($event)"
      ></p-chips>
    </ng-container>
  </ng-container>
  <ng-template #elseTemplate>
    <label class="mb-2" *ngIf="options.label"
      >{{ options.label | translate }}
      <span
        *ngIf="options?.validators?.required"
        [pTooltip]="'BUTTONS.required' | translate"
        tooltipPosition="top"
        class="text-pink-500"
        >*</span
      ></label
    >
    <p-chips
      styleClass="w-full"
      class="w-full"
      [formControlName]="options.formControlName"
      (input)="onChange($event)"
    ></p-chips>
  </ng-template>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
<app-help-message [message]="'HELP.Chips usage' | translate"></app-help-message>
